import { render, staticRenderFns } from "./NewAttendanceReportMonthly.vue?vue&type=template&id=cf06879e&scoped=true"
import script from "./NewAttendanceReportMonthly.vue?vue&type=script&lang=js"
export * from "./NewAttendanceReportMonthly.vue?vue&type=script&lang=js"
import style0 from "./NewAttendanceReportMonthly.vue?vue&type=style&index=0&id=cf06879e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf06879e",
  null
  
)

export default component.exports